<script setup>
import { useArticleImport } from "@/components/ExternalApps/SalesChannelManagementApp/composables/useArticleImport";
import { onMounted, onUnmounted } from "vue";
import ArticleProgressBar from "@/components/ExternalApps/SalesChannelManagementApp/components/ArticleProgressBar.vue";

const {
  currentArticleImportStatus,
  isMounted,
  checkForPendingWorkingJobs,
  timeout,
  lastStoppedIteration,
  xentralArticleStock
} = useArticleImport();

onMounted(() => {
  isMounted.value = true;
  checkForPendingWorkingJobs();
});

onUnmounted(() => {
  if (timeout.value) {
    clearTimeout(timeout.value);
  }
  isMounted.value = false;
  lastStoppedIteration.value = null;
  xentralArticleStock.value = 0;
});
</script>

<template>
  <ArticleProgressBar
    :current-status="currentArticleImportStatus"
    :title="
      $t('salesChannelManagementApp.journal.articleListBuilding').toString()
    "
    :info="
      $t('salesChannelManagementApp.journal.articleListBuildingInfo').toString()
    "
  />
</template>

<style lang="scss" scoped></style>
